// extracted by mini-css-extract-plugin
module.exports = {"container":"Async__container___1xzzo","loading":"Async__loading___tmyPQ","loadingSpinner":"Async__loadingSpinner___12IyR"};